import { ObservableSocket } from "@game.object/ts-game-toolbox/dist/src/signals/ObservableSocket";

export enum Compare {
    HIGHER,
    LOWER,
    EQUAL,
};

export class GameModel {
    public answers_until_lie = 2;
    public guessing_input = new ObservableSocket<number>(0);
    public hidden_number = new ObservableSocket<number>(0);

    public update(delta_ms: number) {

    }


    public compare_numbers(): Compare {
        let diff = this.hidden_number.get() - this.guessing_input.get();
        if (this.answers_until_lie-- === 0) {
            this.answers_until_lie = 2;
            diff *= -1;
        }
        if (diff < 0) return Compare.LOWER;
        if (diff > 0) return Compare.HIGHER;
        return Compare.EQUAL;
    }

    public reset_guess() {
        this.guessing_input.set(0);
    }

    public add_digit(digit: number) {
        this.guessing_input.set(this.guessing_input.get() * 10 + digit);
    }

    public remove_digit() {
        this.guessing_input.set(Math.trunc(this.guessing_input.get() / 10));
    }

    public reset() {
        this.answers_until_lie = 2;
        this.guessing_input.set(0);
        this.hidden_number.set(Math.trunc(Math.random() * 100));
    }
}